import { Fragment, useState, useEffect, useRef, } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';

import ImageFileNameChange from '../ImageFileNameChange/ImageFileNameChange';
import { useStore } from '../../hook-store/store';


import { marks } from '../../utils/marks';

import './ImageConvert.css'
// import classes from './Footer.module.css';

export default function ConvertConvertList(props) {
  // console.log('Layout.js-props', props);

  const [t] = useTranslation('translation');

  const navigate = useNavigate();

  const [store, dispatch] = useStore();
  const { 
    convertedFiles,
  } = store.imageConvertStore;
  // const { bucketName, allBucketObjects } = store.bucketObjectStore;
  const { gLoading, isAuth } = store.uiStore;

  const [showResultList, setShowResultList] = useState(false);
  const [selectedConvertedId, setSelectedConvertedId] = useState('');
  const [showNameChangeModal, setShowNameChangeModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);



  useEffect(() => {
    if (gLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  },[gLoading]);


  const changeResultFileNameChangeHandler = (changedFile) => {
    console.log(changedFile, selectedConvertedId);

    const updatedFiles = convertedFiles.map(element => {
      console.log(element)
      if (element.id === selectedConvertedId) {
        return {
          ...element,
          file: changedFile,
        }
      } else {
        return element;
      }
    });

    console.log(updatedFiles);

    dispatch('SET_CONVERTEDFILES', updatedFiles);

    dispatch('SHOW_NOTIFICATION', {
      status: '',
      title: 'name change success',
      message: '',
    });

    setTimeout(() => {
      dispatch('CLEAR_NOTIFICATION');
    },1000 * 3);
  };



  
  let imageConvertConvertListBody;


  if (showResultList && convertedFiles.length > 0) {
    imageConvertConvertListBody = (
      <div>
        <section className='imageConvertParamElements'>
          <ul>
            {convertedFiles.map(convertedFile => {
              return (
                <li 
                  className='imageConvertElement'
                  key={convertedFile.id} 
                >
                  <div className='imageConvertConvertListItem'>
                    <img 
                      className='convertResizePreview'
                      style={{maxHeight: "150px", maxWidth:"150px"}}
                      src={URL.createObjectURL(convertedFile.file)}
                      alt="convert selected file" 
                      // onLoad={getImgDimension}
                    />
                    <span>
                      <div className='imageConvertElement'>
                        {convertedFile.file.name} ({numeral(convertedFile.file.size).format('0.0 b')})
                      </div>
                      <div className='imageConvertElement'>
                        <div className="">
                          <button
                            className="btnBase"
                            onClick={() => {
                              setSelectedConvertedId(convertedFile.id);
                              setShowNameChangeModal(true);
                            }}
                          >
                            {t('fileAction.06', 'Change Name')}
                          </button>
                        </div>
                        {showNameChangeModal && selectedConvertedId === convertedFile.id && (
                          <ImageFileNameChange 
                            // currentRenderFile={convertedFile}
                            currentRenderFile={convertedFile.file}
                            // onButtonClick={() => { setSelectedConvertedId(convertedFile.id); }}
                            createUploadFile={changeResultFileNameChangeHandler}
                            onClose={() => { 
                              setShowNameChangeModal(false); 
                              setSelectedConvertedId('');
                            }}
                          />
                        )}
                      </div>
                    </span>
                  </div>
                </li>
              )
            })}
          </ul>
        </section>
      </div>
    )
  }
 




  return (
    <Fragment>
      {convertedFiles.length > 0 && (
        <div className='imageConvertElement'>
          <span
            onClick={() => {
              setShowResultList(!showResultList);
            }}
          >
            {t('imageConvert18', 'Display converted files')} {marks.triangleDown}
          </span>
        </div>
      )}
      <div>
        {imageConvertConvertListBody}
      </div>
    </Fragment>
  );
}

